import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import styled from 'styled-components';
import { useAuthState } from '@/plugins/Auth';
import preOrderAPI from '@/api/preOrder';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ProgressBackdrop from '@/components/ProgressBackdrop';

import Alert from '@/components/Alert';
import { useShoppingCartContext } from '@/contexts/useShoppingCartContext';
import helper from '@/helper';
import { checkout as checkoutForMenu } from '../../../../menu/api/menu';
import { checkout as checkoutForEC } from '../../../../ec/api/api';
import { PAYMENT_METHOD } from './Checkout';
import { paymentMethodMap } from '../../../../menu/containers/PreOrder';
import { voucherShopCheckout } from '../../../../user/api/coupon';

const Page = styled.div`
  min-height: 100vh;
`;

const LinePayPayment = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { token } = useAuthState();
  const [alert, setAlert] = React.useState(undefined);
  const { removePreOrderFromShoppingCart } = useShoppingCartContext();
  const queryParams = queryString.parse(search);

  React.useEffect(() => {
    if (queryParams.cancel) {
      setAlert({
        title: '交易取消',
        message: '交易已被取消，請重新再試一次',
      });
      return;
    }
    if (!queryParams.linePayRequestId || !queryParams.submitLinePay) return;
    const checkoutSummary = JSON.parse(localStorage.getItem('checkoutSummary')) || {};
    const {
      checkoutData,
      couponVoucherId,
      discount,
      from,
      items,
      magicCode,
      totalPrice,
      delivery,
    } = checkoutSummary || {};

    if (from === 'DF_PO') {
      (async () => {
        try {
          const checkoutResult = await checkoutForMenu({
            couponVoucherId,
            items,
            paymentInfo: {
              linePayRequestId: queryParams.linePayRequestId,
              linePayTransactionId: queryParams.transactionId,
            },
            paymentMethod: paymentMethodMap[PAYMENT_METHOD.LINE_PAY],
            token,
          });

          const { status, orderId, message } = checkoutResult || {};

          if (status !== 'success') throw new Error(message || '結帳失敗，請聯繫客人員。');

          history.replace('/menu/checkout/receipt', {
            discount,
            items,
            orderId,
            totalPrice,
          });
        } catch (e) {
          setAlert({
            title: '交易失敗',
            message: e.message,
          });
        }
      })();
    } else if (from === 'EC_PO') {
      (async () => {
        try {
          const checkoutResult = await checkoutForEC({
            items,
            paymentInfo: {
              linePayRequestId: queryParams.linePayRequestId,
              linePayTransactionId: queryParams.transactionId,
            },
            paymentMethod: paymentMethodMap[PAYMENT_METHOD.LINE_PAY],
            token,
            delivery,
          });

          const { status, orderId, message } = checkoutResult || {};

          if (status !== 'success') throw new Error(message || '結帳失敗，請聯繫客人員。');

          history.replace('/ec/checkout/receipt', {
            items,
            orderId,
            totalPrice,
          });
        } catch (e) {
          setAlert({
            title: '交易失敗',
            message: e.message,
          });
        }
      })();
    } else if (from === 'voucherShopCheckout') {
      (async () => {
        try {
          const checkoutResult = await voucherShopCheckout({
            items,
            paymentInfo: {
              linePayRequestId: queryParams.linePayRequestId,
              linePayTransactionId: queryParams.transactionId,
            },
            paymentMethod: paymentMethodMap[PAYMENT_METHOD.LINE_PAY],
            token,
          });

          const { status, orderId, message } = checkoutResult || {};

          if (status !== 'success') throw new Error(message || '結帳失敗，請聯繫客人員。');

          history.replace('/user/coupon', {
            items,
            orderId,
            totalPrice,
            showCheckoutCompletedDialog: true,
          });
        } catch (e) {
          setAlert({
            title: '交易失敗',
            message: e.message,
          });
        }
      })();
    } else {
      preOrderAPI.checkout({
        query: {
          linePayRequestId: queryParams.linePayRequestId,
          transactionId: queryParams.transactionId,
        },
        body: {
          checkoutData,
          magicCode,
          token,
        },
      }).then(({
        status: checkoutStatus,
        orderId,
        message,
      }) => {
        if (checkoutStatus === 'OK') {
          const utmQueryString = helper.getUTMQueryStringFromLocalStorage();
          history.push(`/pre-orders/checkout/receipt${utmQueryString ? `?${utmQueryString}` : ''}`, {
            ...checkoutSummary,
            orderId,
          });
          removePreOrderFromShoppingCart((checkoutData || []).map(({ preOrderId }) => preOrderId));
          return;
        }
        setAlert({
          title: '交易失敗',
          message,
        });
      });
    }
  }, []); // eslint-disable-line 

  const handleGoBack = React.useCallback(() => {
    setAlert(null);
    history.replace('/');
  }, [history, setAlert]);

  return (
    <Page>
      {
       alert ? (
         <Alert
           isOpen
           title={alert?.title || ''}
           content={alert?.message || ''}
           buttons={alert?.buttons || (
           <Button fullWidth onClick={handleGoBack}>
             <Box fontWeight="fontWeightBold" color="support.main">
               確認
             </Box>
           </Button>
          )}
         />
       ) : <ProgressBackdrop isShow />
    }
    </Page>
  );
};

export default LinePayPayment;
